module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k5OZh"))).then(() => parcelRequire('5erN3'));